import { ImCross } from "react-icons/im";
import { MdDoneOutline } from "react-icons/md";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileLeftSection from "../../Components/MobileLeftSection";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import { useState } from "react";

export default function MobileResult({ AnsweDet, Styles, TLatResult }) {
  const [SideOpener, setSideOpner] = useState(false);
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };
  return (
    <>
      {" "}
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} />
        <div className="main-content">
          <MobileHeaderSection Page="TLAT Result" OpenSideMenu={OpenSideMenu} />
          <div className="page-content" id="dashboardPage">
            <div
              style={{
                padding: "0 10px",
              }}
            >
              <div className={Styles.OnlineClassTopSection}>
                <div>
                  {/* <p>21 Aug 2024 10:00 AM</p> */}
                  <p style={{ fontWeight: "600", fontSize: "18px" }}>
                    Scored :{TLatResult}
                  </p>
                </div>
                <table
                  className={Styles.QuestionSec2}
                  style={{ borderRadius: "4px", border: "1px solid blue" }}
                >
                  <tbody>
                    <tr>
                      <td rowspan={1}>
                        {AnsweDet?.map((ev, i) => (
                          <div className={Styles.Qu}>
                            <div>
                              <h4 style={{ fontSize: "20px" }}>Q:{i + 1}</h4>
                              <p className={Styles.Questiondet}>
                                {ev?.Question}
                              </p>
                            </div>
                            <div
                              style={{ margin: "10px 0" }}
                              className={Styles.OptionContainer}
                            >
                              {ev?.Options?.map((el, j) => (
                                <div className={Styles.Options}>
                                  <input
                                    type="radio"
                                    disabled={true}
                                    checked={
                                      ev?.AttemptedAnswer === el ? true : false
                                    }
                                  />
                                  <p
                                    style={{
                                      color:
                                        ev?.CorrectAnswer === el
                                          ? "rgb(64, 225, 64)"
                                          : ev?.AttemptedAnswer === el &&
                                            ev?.CorrectAnswer !=
                                              ev?.AttemptedAnswer
                                          ? "red"
                                          : "black",
                                    }}
                                  >
                                    {el}
                                  </p>
                                </div>
                              ))}
                              {!ev?.AttemptedAnswer ? (
                                <p style={{ color: "grey" }}>
                                  {" "}
                                  <ImCross /> Not Attempted
                                </p>
                              ) : ev?.CorrectAnswer == ev?.AttemptedAnswer ? (
                                <p style={{ color: "rgb(64, 225, 64)" }}>
                                  {" "}
                                  <MdDoneOutline /> Correct Answer
                                </p>
                              ) : (
                                <p style={{ color: "red" }}>
                                  {" "}
                                  <ImCross /> Wrong Answer
                                </p>
                              )}
                            </div>{" "}
                          </div>
                        ))}
                      </td>
                    </tr>

                    {/* <tr>
                  <td>
                    <div>
                      <div className={Styles.NumberQuestionData}>
                        <span>
                          Number of Attempted :{" "}
                          <b style={{ color: "rgb(132, 225, 132)" }}> 0</b>
                        </span>
                        <span>
                          Number of Pending :{" "}
                          <b style={{ color: "blue" }}>30</b>
                        </span>
                        <div className={Styles.QuestionBtns}>
                          <button
                            disabled={CurrentQuestionNumber === 0}
                            className={
                              CurrentQuestionNumber === 0
                                ? Styles.disabled
                                : Styles.active
                            }
                            onClick={() => handlePrev()}
                          >
                            PREV
                          </button>
                          {QuestionData?.length &&
                          QuestionData?.length - 1 == CurrentQuestionNumber &&
                          CurrentQuestionNumber !== 0 ? (
                            <button onClick={() => handleSubmitForm()}>
                              SUBMIT
                            </button>
                          ) : (
                            <button onClick={() => handleNext()}>NEXT</button>
                          )}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className={Styles.NumberQuestionData}>
                      <span>
                        Number of Questions : <b> 30</b>
                      </span>
                      <span>
                        Time : <b>15 min</b>
                      </span>
                    </div>
                  </td>
                </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <MobileBottomMenu Page="Dashboard" />
        </div>
      </div>
    </>
  );
}
